import { useEffect } from 'react'
import { apiUrls } from 'consts'
import getOne from 'utils/getOne'
import getFilterValues from '../utils/getFilterValues'

interface useInitProps {
  id: number
  parentFilterId?: number
  param: string
  setAllOptions: Function
  setDefaultOption: Function
  setOptions: Function
  setDatetimeParam: Function
  setDateParam: Function
  setParentFilterParam: Function
  setParentFilterName: Function
  setFilterParam: Function
  isLoaded?: Function
  isMulti: boolean
  selectAllIsDefault: boolean
  setLabelText: Function
  onSelectOption: Function
  selectAll: Function
  setHasDate: Function
  setHasDatetime: Function
}

const useInit = (props: useInitProps) => {
    useEffect(() => {
        getFilterValues(props.id).then((filterOptions) => {
          props.setAllOptions(filterOptions)

          // set datetime field
          const datetimeOption = filterOptions.find((option) => option.type === 'dt')
          if (typeof datetimeOption !== 'undefined') {
            props.setDatetimeParam(props.param)
            props.setHasDatetime(true)
          }
    
          // set date field
          const dateOption = filterOptions.find((option) => option.type === 'd')
          if (typeof dateOption !== 'undefined') {
            props.setDateParam(props.param)
            props.setHasDate(true)
          }
    
    
          // check if has parent
          if (props.parentFilterId) {
            getOne(apiUrls.filters + '/' + props.parentFilterId).then((newParentFilter) => {
              props.setParentFilterParam(newParentFilter.param)
              props.setParentFilterName(newParentFilter.name)
            })
          }
          else {
            props.setOptions([...filterOptions])
    
            props.isLoaded && props.isLoaded(props.param)
          }
        })
      }, [])
}

export default useInit
